<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key"/>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  /* 143 = top-nav + tag-view + navbar 68 + 38 + 37  */
  min-height: calc(100vh - #{$paddingT});
  width: 100%;
  position: relative;
  overflow: hidden;
}

/* 143 = top-nav + tag-view + navbar 68 + 38 + 37  */
.fixed-header + .app-main {
  padding-top: $paddingT;
  min-height: 100vh;
}

</style>
